import React, {useCallback, useEffect, useState} from 'react'
import {DesignBreadcrumbs} from 'organization/Event/Page/PageBreadcrumbs'
import Header from 'lib/ui/layout/Header'
import {Title} from 'lib/ui/typography'
import Page from 'organization/Event/Page'
import {Alert} from '@material-ui/lab'
import styled from 'styled-components'
import WidgetsList from 'organization/Event/WidgetConfig/WidgetsList'
import {RegenerateTokenButton} from 'organization/Event/WidgetConfig/RegenerateTokenButton'
import {spacing} from 'lib/ui/theme'
import grey from '@material-ui/core/colors/grey'
import SaveButton from 'organization/Event/WidgetConfig/SaveButton'
import TagsConfig from 'organization/Event/WidgetConfig/TagsConfig'
import GroupsConfig from 'organization/Event/WidgetConfig/GroupsConfig'
import AllowedOriginsConfig from 'organization/Event/WidgetConfig/AllowedOriginsConfig'
import SourcesConfig from 'organization/Event/WidgetConfig/SourcesConfig'
import {useWidget} from 'lib/event-api/widgets/use-widget'
import {Widget} from 'Event/Widget/template'

export default function WidgetConfig() {
  const {data: serverWidget} = useWidget()
  const [widget, setWidget] = useState<Widget | null>(null)

  useEffect(() => {
    if (
      (serverWidget && !widget) ||
      (serverWidget && serverWidget?.token !== widget?.token)
    ) {
      setWidget(serverWidget)
    }
  }, [serverWidget, widget])

  const updateWidget = useCallback((updatedFields: Partial<Widget>) => {
    setWidget((prev) => (prev ? {...prev, ...updatedFields} : prev))
  }, [])

  return (
    <DesignBreadcrumbs page="Widgets">
      <>
        <Page>
          <Holder>
            <StyledHeader>
              <Title>Widgets</Title>
            </StyledHeader>
            <Alert severity="warning" style={{marginBottom: '16px'}}>
              <>
                <b>Widgets are not secure</b> <br />
                Anybody could potentially use them to create attendees for your
                event. <br />
                This is only recommended for advanced users and typically for
                Free events. <br />
                <br />
                <b>Hint:</b> If your widget isn't rendering, please check your
                browser's console.
              </>
            </Alert>

            <ConfigBar>
              <RegenerateTokenButton />
              <SaveButton widget={widget} />
            </ConfigBar>

            <>
              <SubTitle>Configuration</SubTitle>
              <SubTitleDescription>
                Configure various settings for widgets
              </SubTitleDescription>
              <h5>Allowed Origins</h5>

              <AllowedOriginsConfig
                widget={widget}
                updateWidget={updateWidget}
              />
              <h5>Add Tags to created users via Widgets</h5>
              <TagsConfig widget={widget} updateWidget={updateWidget} />

              <h5>Add Groups to created users via Widgets</h5>
              <GroupsConfig widget={widget} updateWidget={updateWidget} />

              <SubTitle>Sources</SubTitle>
              <SubTitleDescription>
                Configure where user data should be sourced from
              </SubTitleDescription>

              <SourcesConfig widget={widget} updateWidget={updateWidget} />

              <SubTitle>Code Generator</SubTitle>
              <SubTitleDescription>
                Configure where user data should be sourced from
              </SubTitleDescription>
              <WidgetsList widget={widget} updateWidget={updateWidget} />
            </>
          </Holder>
        </Page>
      </>
    </DesignBreadcrumbs>
  )
}

const Holder = styled.div`
  margin-bottom: ${spacing[14]};
  position: relative;
`

const ConfigBar = styled.div`
  position: sticky !important;
  top: 0 !important;
  height: 50px !important;
  border-bottom: 1px solid ${grey[300]};
  display: flex;
  align-items: center;
  justify-content: end;
  padding: 0 ${(props) => props.theme.spacing[4]};
  background: #ffffff;
  z-index: 50;
`

const StyledHeader = styled(Header)`
  margin-bottom: ${spacing[4]} !important;
`

export const SubTitle = styled.h4`
  margin-top: ${spacing[10]};
`

const SubTitleDescription = styled.p`
  margin-bottom: ${spacing[6]};
  margin-top: -${spacing[2]};
  font-size: 0.9rem;
  color: #6a7181;
`
